function triggerOverlay() {
  const wrapper = document.querySelector('.mega-menu-wrapper');
  const nav = wrapper.querySelector('.header__inline-menu');
  const overlay = wrapper.querySelector('.mega-menu-overlay');

  if (!nav || !overlay) return;

  function shouldShowOverlay(menuItem) {
    const content = menuItem.querySelector('.mega-menu__list');
    return content && content.querySelector('li');
  }

  function showOverlay(menuItem) {
    if (shouldShowOverlay(menuItem)) {
      overlay.classList.add('visible');
      nav.classList.add('is-mega-open');
    }
  }

  function hideOverlay() {
    overlay.classList.remove('visible');
    nav.classList.remove('is-mega-open');
  }

  nav.querySelectorAll('.nav-hover-zone').forEach((hoverZone) => {
    hoverZone.addEventListener('mouseenter', () => {
      resizeMegaMenus(hoverZone);
      showOverlay(hoverZone);
    });

    hoverZone.addEventListener('mouseleave', () => {
      hideOverlay();
    });
  });
}

// Set the overlay top value
function updateOverlayTop() {
  const mainContent = document.querySelector('.content-for-layout');
  const overlay = document.querySelector('.mega-menu-overlay');
  if (mainContent && overlay) {
    const headerBottom = mainContent.getBoundingClientRect().top;
    overlay.style.top = `${headerBottom}px`;
  }
}

function resizeMegaMenus(menu) {
  if (!menu) return;

  const content = menu.querySelector('.mega-menu__content');
  if (!content) return;

  // Reset styles
  content.style.right = '';
  content.style.left = '';
  content.style.transform = '';

  const columns = parseInt(content.dataset.columns, 10) || 1;
  const columnWidth = 370;
  const padding = 48;
  const finalWidth = Math.min(columns * columnWidth, window.innerWidth - padding * 2);

  content.style.width = `${finalWidth}px`;

  const menuRect = menu.getBoundingClientRect();
  const menuCenter = menuRect.left + menuRect.width / 2;
  const left = Math.max(padding, Math.min(menuCenter - finalWidth / 2, window.innerWidth - finalWidth - padding));

  content.style.left = `${left}px`;

  const newColumnWidth = finalWidth / columns;
  content.querySelectorAll('.mega-menu__column').forEach((col) => {
    col.style.flex = `0 0 ${newColumnWidth}px`;
    col.style.maxWidth = `${newColumnWidth}px`;
  });
}

function gradientVisibility() {
  const scrollContainer = document.querySelector('.facets-container');
  if (!scrollContainer) return; // prevent error on non-facet pages

  const wrapper = scrollContainer.closest('.facets-wrapper');
  if (!wrapper) return;

  const updateGradientVisibility = () => {
    const scrollLeft = scrollContainer.scrollLeft;
    const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

    wrapper.style.setProperty('--left-opacity', scrollLeft > 0 ? '1' : '0');
    wrapper.style.setProperty('--right-opacity', scrollLeft < maxScrollLeft - 1 ? '1' : '0');
  };

  scrollContainer.addEventListener('scroll', updateGradientVisibility);
  window.addEventListener('resize', updateGradientVisibility);
  updateGradientVisibility();
}

document.addEventListener('DOMContentLoaded', function () {
  triggerOverlay();
  gradientVisibility();
});

window.addEventListener('load', () => {
  updateOverlayTop();
});

window.addEventListener('resize', () => {
  document.querySelectorAll('.mega-menu').forEach((menu) => {
    resizeMegaMenus(menu);
  });
  updateOverlayTop();
});

window.addEventListener('scroll', () => {
  updateOverlayTop();
});
